import React from "react";
import { Button, Card, Col, Form, Image, Row } from "react-bootstrap";
import { propertyServices } from "../../APIServices/GlobalManagements/propertyServices";
import { useState } from "react";
import { useEffect } from "react";
import { userServices } from "../../APIServices/UserData/userServices";
import { superAdminMetaServices } from "../../APIServices/MetaManagement/superAdminMetaServices";
const OverviewData = ({ getCurrectLoginUser, currentUserData }) => {
  const [propertyId, setPropertyId] = useState("")
  const [apiKey, setAPIKey] = useState("")
  const [name, setName] = useState("")
  const [domain, setDomain] = useState("")
  const [countryId, setCountryId] = useState("")
  const [icon, setIcon] = useState("")
  const [categoryId, setCategoryId] = useState("")
  const [subCategoryId, setSubCategoryId] = useState("")
  const [description, setDescription] = useState("")
  const [countryList, setCountryList] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [subCategoryList, setSubCategoryList] = useState([])
  const [secureMode, setSecureMode] = useState(false)
  const [discoveryVisibility, setDiscoveryVisibility] = useState(false)
  const [visitorIPTrack, setVisitorIPTrack] = useState(true)

  const getSingleProperty = async () => {
    let data = await propertyServices.getSingleProperty(currentUserData?.loginPropertyId)
    setPropertyId(data?.data?.propertyId || "")
    setName(data?.data?.name || "")
    setDomain(data?.data?.domain || "")
    setCountryId(data?.data?.countryId || "")
    setIcon(data?.data?.icon || "")
    setCategoryId(data?.data?.categoryId || "")
    setSubCategoryId(data?.data?.subCategoryId || "")
    setDescription(data?.data?.description || "")
    setSecureMode(data?.data?.secureMode)
    setDiscoveryVisibility(data?.data?.discoveryVisibility)
    setVisitorIPTrack(data?.data?.visitorIPTrack)
    setAPIKey(data?.data?.apiKey)
  }

  const getCountries = async () => {
    let data = await userServices.getCountries()
    setCountryList(data?.data || [])
  }

  const getDiscoveryCategoryList = async () => {
    let data = await superAdminMetaServices.getDiscoveryCategoryList()
    setCategoryList(data?.data || [])
  }

  const getDiscoverySubCategoryList = async () => {
    let data = await superAdminMetaServices.getDiscoverySubCategoryList(categoryId)
    setSubCategoryList(data?.data || [])
  }

  const updatedPropertyData = async () => {
    let userData = {}
    userData.propertyId = propertyId
    userData.name = name
    userData.domain = domain
    userData.countryId = countryId
    userData.icon = icon
    userData.categoryId = categoryId
    userData.subCategoryId = subCategoryId
    userData.description = description
    userData.secureMode = secureMode
    userData.discoveryVisibility = discoveryVisibility
    userData.visitorIPTrack = visitorIPTrack
    let data = await propertyServices.updatedProperty(userData)
    if (data?.statusCode === 200) {
      getCurrectLoginUser()
    }
  }

  useEffect(() => {
    if (currentUserData) {
      getSingleProperty();
    }
  }, [currentUserData]);

  useEffect(() => {
    getDiscoveryCategoryList();
    getCountries();
  }, []);

  useEffect(() => {
    if (categoryId) {
      getDiscoverySubCategoryList();
    }
  }, [categoryId]);
  return (
    <>
      <div className="h-100 d-flex flex-column">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <Form.Group className="lh-1">
              <h6 className="fw-semibold m-0 d-block">Property Settings</h6>
              <Form.Text style={{ fontSize: 13 }} className="text-muted">
                Manage identity, discovery, and security preferences
              </Form.Text>
            </Form.Group>
            <Button
              onClick={updatedPropertyData}
              variant="primary" size="sm">
              Save Changes
            </Button>
          </div>
        </div>
        <div className="flex-grow-1 overflow-auto p-4">
          <Row className="g-4">
            <Col xxl={8}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold mb-3">Property Identity</h6>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Property Name</Form.Label>
                        <Form.Control
                          onChange={(e) => setName(e.target.value)}
                          value={name}
                          placeholder="Enter property name"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Website URL</Form.Label>
                        <Form.Control
                          onChange={(e) => setDomain(e.target.value)}
                          value={domain}
                          placeholder="Enter Website URL"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Region</Form.Label>
                        <Form.Select
                          onChange={(e) => setCountryId(e.target.value)}
                          value={countryId}
                        >
                          <option value={""}>Select Country</option>
                          {countryList?.map((item => (
                            <option value={item?.iso2}>{item?.name}</option>
                          )))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    <div>
                      <h6 className="fw-semibold mb-1">
                        Discovery & Visibility
                      </h6>
                      <small className="text-muted">
                        Control how your property appears publicly
                      </small>
                    </div>
                    <Form.Check
                      type="switch"
                      onChange={(e) => setDiscoveryVisibility(!discoveryVisibility)}
                      checked={discoveryVisibility}
                    />
                  </div>

                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Category</Form.Label>
                        <Form.Select
                          onChange={(e) => setCategoryId(e.target.value)}
                          value={categoryId}
                        >
                          <option value={""}>Select Category</option>
                          {categoryList?.map((item => (
                            <option value={item?.categoryId}>{item?.name}</option>
                          )))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Sub Category</Form.Label>
                        <Form.Select
                          onChange={(e) => setSubCategoryId(e.target.value)}
                          value={subCategoryId}
                        >
                          <option value={""}>Select Sub Category</option>
                          {subCategoryList?.map((item => (
                            <option value={item?.subCategoryId}>{item?.name}</option>
                          )))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <h6 className="fw-semibold mb-3">About This Property</h6>
                  <Form.Control
                    as="textarea"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    rows={4}
                    placeholder="Describe your product, service, or organization..."
                  />
                </Card.Body>
              </Card>
            </Col>

            <Col xxl={4}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold mb-3">Brand Image</h6>

                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded border bg-light d-flex align-items-center justify-content-center"
                      style={{ width: 96, height: 96 }}
                    >
                      <Image
                        src={icon}
                        rounded
                        fluid
                      />
                    </div>

                    <div>
                      <small className="text-muted d-block mb-2">
                        PNG or JPG · 512×512
                      </small>
                      <Button size="sm" variant="outline-primary">
                        Upload Image
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <h6 className="fw-semibold mb-4">Security & API Access</h6>

                  <Form.Group className="mb-3">
                    <Form.Label>Property ID</Form.Label>
                    <Form.Control
                      size="sm"
                      readOnly
                      value={propertyId}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>JavaScript API Key</Form.Label>
                    <Form.Control
                      size="sm"
                      readOnly
                      value={apiKey}
                    />
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-medium">Secure Mode</span>
                    <Form.Check
                      type="switch"
                      onChange={(e) => setSecureMode(!secureMode)}
                      checked={secureMode}
                    />
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fw-medium">Visitor IP Tracking</span>
                    <Form.Check
                      type="switch"
                      onChange={(e) => setVisitorIPTrack(!visitorIPTrack)}
                      checked={visitorIPTrack}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default OverviewData;
